import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

const propTypes = {
  number: PropTypes.number.isRequired,
  content: PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]).isRequired
}

const defaultProps = {

}

// Replaces the old react-bootstrap Badge (variant="primary" rounded-circle).
// Uses the brand primary (#00b6e0) via the theme.
const InstructionLine = (props) => {
  const { number, content } = props;

  return (
    <div className="flex align-items-center mb20">
      <div className="mr12">
        <Box
          sx={{
            height: 30,
            width: 30,
            borderRadius: "50%",
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          { number }
        </Box>
      </div>
      <div style={{ fontSize: 14 }}>
        { content }
      </div>
    </div>
  )
};

InstructionLine.propTypes = propTypes;
InstructionLine.defaultProps = defaultProps;

export default InstructionLine;
